/* =========================================================================
   Pure n' Bio · Miss W Pro Bundle Landing
   bundle-landing-miss-w-pro.js
   Vanilla JS, no dependencies. Real Shopify cart via /cart/add.js + /cart.js.
   Dual threshold: 299 SAR (shipping) and 350 SAR (gift — pick one).
   ========================================================================= */

(function () {
  'use strict';

  // ------------------------------------------------------------------------
  // CONFIG — pulled from window.PnbBundleConfig (injected by the section).
  // ------------------------------------------------------------------------
  var _CFG = (typeof window !== 'undefined' && window.PnbBundleConfig) || {};
  var THRESHOLD = _CFG.threshold || 350;             // SAR — free gift threshold
  var SHIPPING_THRESHOLD = _CFG.shippingThreshold || 299; // SAR — free shipping
  var GIFT_PROP_KEY = '_gift';
  var GIFT_PROP_VALUE = 'miss-w-pro';

  var SAR_ICON = '<span class="pnb-sar" aria-label="SAR"></span>';
  var IS_RTL = document.documentElement.dir === 'rtl' || !!document.querySelector('.pnb-bundle.is-rtl');

  // Cached cart state — refreshed from /cart.js on every mutation.
  var STATE = { cart: null, syncing: false };

  // ------------------------------------------------------------------------
  // L10N
  // ------------------------------------------------------------------------
  var L = IS_RTL ? {
    inBundle: 'تمت اضافتها للمجموعة',
    add: 'أضيفي للمجموعة',
    soldout: 'نفذت الكمية',
    onlyLeft: function (n) { return 'تبقى ' + toArDigits(n) + ' فقط'; },
    inStock: 'متوفر',
    toGift: function (n) { return 'يتبقى ' + toArDigits(n) + ' ' + SAR_ICON + ' على هديتُكِ'; },
    unlocked: 'الهدية مُفعّلة',
    shippingTo: function (n) { return 'يتبقى ' + toArDigits(n) + ' ' + SAR_ICON + ' على الشّحن المجاني'; },
    shippingDone: 'الشّحن المجاني مُفعّل',
    remaining: function (n) { return toArDigits(n) + ' ' + SAR_ICON; },
    backToBundle: 'عودي لمجموعتكِ',
    selectVariant: 'اختاري الخيار',
    showAll: 'عرض جميع المنتجات',
    showLess: 'عرض أقل',
    faqShowMore: 'عرض المزيد من الأسئلة',
    faqShowLess: 'عرض أقل',
  } : {
    inBundle: 'In bundle',
    add: 'Add to bundle',
    soldout: 'Sold out',
    onlyLeft: function (n) { return 'Only ' + n + ' left'; },
    inStock: 'In stock',
    toGift: function (n) { return n + ' ' + SAR_ICON + ' to your free gift'; },
    unlocked: 'Free gift unlocked',
    shippingTo: function (n) { return n + ' ' + SAR_ICON + ' to free shipping'; },
    shippingDone: 'Free shipping unlocked',
    remaining: function (n) { return n + ' ' + SAR_ICON; },
    backToBundle: 'Back to your bundle',
    selectVariant: 'Select an option',
    showAll: 'Show all products',
    showLess: 'Show less',
    faqShowMore: 'Show more questions',
    faqShowLess: 'Show fewer questions',
  };

  // CONFIG-INJECTED LABEL OVERRIDES — let the section pass locale-aware
  // strings without forking the JS file.
  (function applyConfigLabels() {
    var lbl = _CFG && _CFG.labels;
    if (!lbl || typeof lbl !== 'object') return;
    function fmt(tpl) { return function (n) { return String(tpl).replace('%AMOUNT%', toArDigits(n)); }; }
    if (lbl.toGift) L.toGift = fmt(lbl.toGift);
    if (lbl.toShipping) L.shippingTo = fmt(lbl.toShipping);
    if (lbl.shippingDone) L.shippingDone = lbl.shippingDone;
    if (lbl.unlocked) L.unlocked = lbl.unlocked;
    if (lbl.inBundle) L.inBundle = lbl.inBundle;
    if (lbl.add) L.add = lbl.add;
    if (lbl.soldout) L.soldout = lbl.soldout;
    if (lbl.backToBundle) L.backToBundle = lbl.backToBundle;
  })();

  function toArDigits(n) {
    if (!IS_RTL) return n;
    var map = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return String(n).replace(/[0-9]/g, function (d) { return map[parseInt(d, 10)]; });
  }

  // ------------------------------------------------------------------------
  // CART STATE — real Shopify cart via /cart.js + /cart/add.js + /cart/change.js
  // ------------------------------------------------------------------------
  function cartFetch() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (c) { STATE.cart = c; return c; });
  }

  function notifyThemeCartChanged() {
    // Tell the theme's cart-drawer + cart-bubble to re-fetch from /cart.js.
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: STATE.cart } }));
    } catch (e) { /* old browsers */ }
  }

  function cartAdd(items) {
    var arr = Array.isArray(items) ? items : [items];
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: arr })
    }).then(function (r) { return r.ok ? r.json() : r.json().then(function (j) { return Promise.reject(j); }); })
      .then(function (data) { notifyThemeCartChanged(); return data; });
  }

  function cartChange(payload) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) { STATE.cart = data; notifyThemeCartChanged(); return data; });
  }

  function cartTotalSar(cart) {
    var c = cart || STATE.cart;
    if (!c) return 0;
    return Math.round((c.total_price || 0) / 100);
  }

  // Total excluding the gift line — gift is at 100% off via the BXGY discount,
  // but Shopify's cart total_price reports the pre-discount price. We don't
  // want the gift to affect the rewards-bar total (that would be misleading).
  function cartTotalNonGiftSar(cart) {
    var c = cart || STATE.cart;
    if (!c || !c.items) return 0;
    var sumCents = 0;
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      var p = it.properties || {};
      if (p[GIFT_PROP_KEY] === GIFT_PROP_VALUE) continue;
      sumCents += (it.line_price || (it.price * (it.quantity || 1)) || 0);
    }
    return Math.round(sumCents / 100);
  }

  function cartHasVariant(variantId) {
    var c = STATE.cart;
    if (!c || !c.items) return false;
    var vid = Number(variantId);
    if (!vid) return false;
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      var p = it.properties || {};
      if (p[GIFT_PROP_KEY] === GIFT_PROP_VALUE) continue; // ignore gift line
      if (Number(it.variant_id) === vid) return true;
    }
    return false;
  }

  function findGiftLineKey(cart) {
    var c = cart || STATE.cart;
    if (!c || !c.items) return null;
    for (var i = 0; i < c.items.length; i++) {
      var p = c.items[i].properties || {};
      if (p[GIFT_PROP_KEY] === GIFT_PROP_VALUE) return c.items[i].key;
    }
    return null;
  }

  function getSelectedGiftVariantId() {
    var checked = document.querySelector('.pnb-gift-radio:checked');
    if (checked && checked.value) return Number(checked.value);
    return null;
  }

  // Reconcile gift line item with current cart total and selected radio.
  // Always re-fetches /cart.js first so the decision uses live state, not
  // possibly-stale STATE.cart (e.g. customer edited cart in another tab).
  function syncGiftItem() {
    if (STATE.syncing) return Promise.resolve();
    STATE.syncing = true;
    var done = function () { STATE.syncing = false; };

    return cartFetch().then(function () {
      var nonGiftTotal = cartTotalNonGiftSar();
      var existingKey = findGiftLineKey();
      var targetVariant = (nonGiftTotal >= THRESHOLD) ? getSelectedGiftVariantId() : null;

      // If existing item already matches the target variant, nothing to do.
      if (existingKey && targetVariant) {
        var existing = STATE.cart.items.find(function (it) { return it.key === existingKey; });
        if (existing && Number(existing.variant_id) === Number(targetVariant)) {
          return null;
        }
      }

      var p = Promise.resolve();
      if (existingKey) {
        p = p.then(function () { return cartChange({ id: existingKey, quantity: 0 }); });
      }
      if (targetVariant) {
        p = p.then(function () {
          var item = { id: targetVariant, quantity: 1, properties: {} };
          item.properties[GIFT_PROP_KEY] = GIFT_PROP_VALUE;
          return cartAdd(item);
        }).then(function () { return cartFetch(); });
      }
      return p;
    }).then(function () { renderState(); done(); }).catch(function () { done(); });
  }

  // ------------------------------------------------------------------------
  // RENDER — sync rewards panel + product card states from real cart
  // ------------------------------------------------------------------------
  function renderState() {
    var total = cartTotalNonGiftSar();
    var shipPct = Math.min(100, (total / SHIPPING_THRESHOLD) * 100);
    var giftPct = Math.min(100, (total / THRESHOLD) * 100);
    var shipRemain = Math.max(0, SHIPPING_THRESHOLD - total);
    var giftRemain = Math.max(0, THRESHOLD - total);
    var shipUnlocked = total >= SHIPPING_THRESHOLD;
    var giftUnlocked = total >= THRESHOLD;

    var totalEl = document.getElementById('pnb-rewards-total');
    var shipFillEl = document.getElementById('pnb-reward-shipping-fill');
    var shipTextEl = document.getElementById('pnb-reward-shipping-text');
    var giftFillEl = document.getElementById('pnb-reward-gift-fill');
    var giftTextEl = document.getElementById('pnb-reward-gift-text');
    var shipRow = shipFillEl ? shipFillEl.closest('.pnb-reward-row') : null;
    var giftRow = giftFillEl ? giftFillEl.closest('.pnb-reward-row') : null;

    var rewardSection = document.getElementById('pnb-reward');
    var rewardOverlay = document.getElementById('pnb-reward-overlay');
    var remainingEl = document.getElementById('pnb-remaining');

    if (totalEl) totalEl.innerHTML = toArDigits(total) + ' ' + SAR_ICON;
    if (shipFillEl) shipFillEl.style.width = shipPct + '%';
    if (giftFillEl) giftFillEl.style.width = giftPct + '%';
    if (shipRow) shipRow.classList[shipUnlocked ? 'add' : 'remove']('is-unlocked');
    if (giftRow) giftRow.classList[giftUnlocked ? 'add' : 'remove']('is-unlocked');
    if (shipTextEl) shipTextEl.innerHTML = shipUnlocked ? L.shippingDone : L.shippingTo(shipRemain);
    if (giftTextEl) giftTextEl.innerHTML = giftUnlocked ? L.unlocked : L.toGift(giftRemain);

    if (giftRemain > 0) {
      if (remainingEl) remainingEl.innerHTML = L.remaining(giftRemain);
      if (rewardSection) rewardSection.classList.add('is-locked');
      if (rewardOverlay) rewardOverlay.style.display = 'flex';
    } else {
      if (rewardSection) rewardSection.classList.remove('is-locked');
      if (rewardOverlay) rewardOverlay.style.display = 'none';
    }

    // Sync product cards: highlight any whose default variant is in cart.
    document.querySelectorAll('[data-variant-id]').forEach(function (el) {
      var vid = el.getAttribute('data-variant-id');
      var card = el.closest('.pnb-card, .pnb-best-item');
      var btn = el.matches('.pnb-btn-add') ? el : (card ? card.querySelector('.pnb-btn-add') : null);

      if (cartHasVariant(vid)) {
        if (card) card.classList.add('is-added');
        if (btn) {
          btn.classList.add('is-added');
          btn.textContent = L.inBundle;
        }
      } else {
        if (card) card.classList.remove('is-added');
        if (btn && !btn.disabled) {
          btn.classList.remove('is-added');
          btn.textContent = L.add;
        }
      }
    });
  }

  // ------------------------------------------------------------------------
  // PRODUCT INTERACTIONS — real /cart/add.js
  // ------------------------------------------------------------------------
  function handleCardClick(e) {
    var card = e.target.closest('.pnb-card');
    if (!card) return;
    if (e.target.matches('.pnb-btn-add')) return; // let button handler take it
    var handle = card.getAttribute('data-handle');
    if (handle) openQuickView(handle);
  }

  function handleBestsellerClick(e) {
    var item = e.target.closest('.pnb-best-item');
    if (!item) return;
    if (e.target.matches('.pnb-btn-add')) return;
    var handle = item.getAttribute('data-product-handle');
    if (handle) openQuickView(handle);
  }

  function flashAdded(btn, errored) {
    var orig = btn.dataset.origLabel || btn.textContent;
    btn.dataset.origLabel = orig;
    btn.textContent = errored
      ? (IS_RTL ? '⚠ غير متاح' : '⚠ Unavailable')
      : L.inBundle;
    setTimeout(function () {
      // Don't stomp on a card that's now "in bundle" — let renderState()
      // settle the label after the cart re-fetch.
      if (btn.classList.contains('is-added')) return;
      btn.textContent = orig;
    }, 1600);
  }

  function handleAddDirectly(e) {
    var btn = e.target.closest('.pnb-btn-add');
    if (!btn) return;
    if (btn.closest('.pnb-modal')) return; // quick-view modal has its own handler

    e.stopPropagation();
    e.preventDefault();
    if (btn.disabled) return;

    var vid = btn.getAttribute('data-variant-id');
    var hasVariants = btn.getAttribute('data-has-variants') === 'true';

    // If product has multiple variants and isn't already in cart, open
    // quick-view so the customer can pick a variant.
    if (hasVariants && !cartHasVariant(vid)) {
      var handle = btn.getAttribute('data-product-handle');
      if (handle) { openQuickView(handle); return; }
    }

    if (!vid) return;

    btn.disabled = true;
    cartAdd([{ id: Number(vid), quantity: 1 }])
      .then(function () { return cartFetch(); })
      .then(function () { return syncGiftItem(); })
      .then(function () { renderState(); flashAdded(btn, false); })
      .catch(function () { flashAdded(btn, true); })
      .then(function () { btn.disabled = false; });
  }

  // ------------------------------------------------------------------------
  // QUICK-VIEW POPUP
  // ------------------------------------------------------------------------
  var qvCurrentSlide = 0;
  var qvSlideCount = 0;
  var qvSelectedOptions = {};
  var qvProductData = null;
  var _qvCache = {};

  function _adaptShopifyProduct(sp) {
    return {
      handle: sp.handle,
      title: sp.title,
      brand: sp.vendor,
      description: (sp.description || '').replace(/<[^>]*>/g, '').slice(0, 600),
      images: (sp.images || []).slice(0, 8),
      options: (sp.options || []).map(function (o) {
        if (typeof o === 'string') return { name: o, values: [] };
        return { name: o.name, values: o.values || [] };
      }),
      variants: (sp.variants || []).map(function (v) {
        return {
          id: v.id,
          title: v.title,
          price: Math.round((v.price || 0) / 100),
          available: !!v.available,
          inventoryQuantity: null,
          options: [v.option1, v.option2, v.option3].filter(function (x) { return x != null; })
        };
      })
    };
  }

  function openQuickView(handle) {
    var modal = document.getElementById('pnb-qv-modal');
    if (!modal) return;

    function _mount(data) {
      qvProductData = data;
      qvCurrentSlide = 0;
      qvSelectedOptions = {};
      if (qvProductData.options) {
        qvProductData.options.forEach(function (opt) {
          qvSelectedOptions[opt.name] = opt.values[0];
        });
      }
      renderQuickView();
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    var dataEl = document.querySelector('[data-pnb-product="' + handle + '"]');
    if (dataEl) {
      try { _mount(JSON.parse(dataEl.textContent)); return; } catch (e) { /* fall through */ }
    }

    if (_qvCache[handle]) { _mount(_qvCache[handle]); return; }

    var grid = document.getElementById('pnb-product-grid');
    var root = (grid && grid.getAttribute('data-routes-root')) || '/';
    if (root.slice(-1) !== '/') root += '/';
    var url = root + 'products/' + encodeURIComponent(handle) + '.js';

    modal.classList.add('is-loading');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (sp) {
        var adapted = _adaptShopifyProduct(sp);
        _qvCache[handle] = adapted;
        modal.classList.remove('is-loading');
        _mount(adapted);
      })
      .catch(function (err) {
        console.error('Quick-view fetch failed for', handle, err);
        modal.classList.remove('is-loading');
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      });
  }

  function closeQuickView() {
    var modal = document.getElementById('pnb-qv-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    qvProductData = null;
  }

  function renderQuickView() {
    if (!qvProductData) return;
    var p = qvProductData;
    var current = currentVariant();

    var trackEl = document.getElementById('pnb-qv-track');
    var dotsEl = document.getElementById('pnb-qv-dots');
    if (trackEl && p.images && p.images.length) {
      qvSlideCount = p.images.length;
      trackEl.innerHTML = p.images.map(function (src) {
        return '<div class="pnb-qv-slide"><img src="' + src + '" alt=""></div>';
      }).join('');
      trackEl.style.transform = 'translateX(' + (IS_RTL ? '' : '-') + (qvCurrentSlide * 100) + '%)';
      if (IS_RTL) trackEl.style.transform = 'translateX(' + (qvCurrentSlide * 100) + '%)';
    }
    if (dotsEl && qvSlideCount > 1) {
      dotsEl.innerHTML = '';
      for (var i = 0; i < qvSlideCount; i++) {
        var dot = document.createElement('div');
        dot.className = 'pnb-qv-dot' + (i === qvCurrentSlide ? ' is-active' : '');
        dot.setAttribute('data-slide', i);
        dotsEl.appendChild(dot);
      }
    } else if (dotsEl) {
      dotsEl.innerHTML = '';
    }

    var brandEl = document.getElementById('pnb-qv-brand');
    var titleEl = document.getElementById('pnb-qv-title');
    var priceEl = document.getElementById('pnb-qv-price');
    var stockEl = document.getElementById('pnb-qv-stock');
    var descEl = document.getElementById('pnb-qv-desc');
    var optionsEl = document.getElementById('pnb-qv-options');
    var addBtn = document.getElementById('pnb-qv-add');

    if (brandEl) brandEl.textContent = p.brand || '';
    if (titleEl) titleEl.textContent = p.title || '';
    if (priceEl && current) priceEl.innerHTML = toArDigits(current.price) + ' ' + SAR_ICON;

    var tabbyEl = document.getElementById('pnb-qv-tabby');
    if (tabbyEl) {
      var tabbyTpl = _CFG && _CFG.labels && _CFG.labels.tabbyLine;
      if (tabbyTpl && current && current.available && current.price >= 60) {
        var amt = Math.ceil(current.price / 4);
        tabbyEl.innerHTML = String(tabbyTpl).replace('%AMOUNT%', toArDigits(amt));
        tabbyEl.hidden = false;
      } else {
        tabbyEl.hidden = true;
        tabbyEl.textContent = '';
      }
    }
    if (descEl) descEl.innerHTML = p.description || '';

    if (stockEl && current) {
      stockEl.className = 'pnb-qv-stock';
      if (!current.available) {
        stockEl.classList.add('is-out');
        stockEl.textContent = L.soldout;
      } else if (current.inventoryQuantity !== null && current.inventoryQuantity <= 5 && current.inventoryQuantity > 0) {
        stockEl.classList.add('is-low');
        stockEl.textContent = L.onlyLeft(current.inventoryQuantity);
      } else {
        stockEl.classList.add('is-instock');
        stockEl.textContent = L.inStock;
      }
    }

    if (optionsEl) {
      if (!p.options || !p.options.length || (p.options.length === 1 && p.options[0].values.length === 1)) {
        optionsEl.innerHTML = '';
      } else {
        optionsEl.innerHTML = p.options.map(function (opt) {
          var rows = opt.values.map(function (val) {
            var testOpts = Object.assign({}, qvSelectedOptions);
            testOpts[opt.name] = val;
            var matchVar = findVariant(testOpts);
            var soldout = !matchVar || !matchVar.available;
            var selected = qvSelectedOptions[opt.name] === val;
            return '<button class="pnb-qv-variant' +
              (selected ? ' is-selected' : '') +
              (soldout ? ' is-soldout' : '') +
              '" data-option="' + opt.name + '" data-value="' + val + '"' +
              (soldout ? ' disabled' : '') + '>' + val + '</button>';
          }).join('');
          return '<div class="pnb-qv-option">' +
            '<span class="pnb-qv-option-label">' + opt.name + '</span>' +
            '<div class="pnb-qv-option-row">' + rows + '</div></div>';
        }).join('');
      }
    }

    if (addBtn && current) {
      addBtn.setAttribute('data-variant-id', current.id);
      if (!current.available) {
        addBtn.disabled = true;
        addBtn.textContent = L.soldout;
      } else if (cartHasVariant(current.id)) {
        addBtn.disabled = true;
        addBtn.textContent = L.inBundle;
      } else {
        addBtn.disabled = false;
        addBtn.textContent = L.add;
      }
    }

    var knowMoreEl = document.getElementById('pnb-qv-know-more');
    if (knowMoreEl && p.handle) {
      var grid = document.getElementById('pnb-product-grid');
      var root = (grid && grid.getAttribute('data-routes-root')) || '/';
      if (root.slice(-1) !== '/') root += '/';
      knowMoreEl.href = root + 'products/' + encodeURIComponent(p.handle);
    }
  }

  function currentVariant() {
    if (!qvProductData) return null;
    return findVariant(qvSelectedOptions);
  }

  function findVariant(opts) {
    if (!qvProductData || !qvProductData.variants) return null;
    return qvProductData.variants.find(function (v) {
      return v.options.every(function (o, i) {
        return o === opts[qvProductData.options[i].name];
      });
    }) || qvProductData.variants[0];
  }

  function handleQvAdd() {
    var addBtn = document.getElementById('pnb-qv-add');
    if (!addBtn || addBtn.disabled) return;
    var v = currentVariant();
    if (!v || !v.available) return;
    var origLabel = addBtn.textContent;

    addBtn.disabled = true;
    cartAdd([{ id: Number(v.id), quantity: 1 }])
      .then(function () { return cartFetch(); })
      .then(function () { return syncGiftItem(); })
      .then(function () {
        renderState();
        addBtn.textContent = L.inBundle;
        addBtn.classList.add('is-added');
      })
      .catch(function () {
        addBtn.textContent = IS_RTL ? '⚠ تعذّر الإضافة' : '⚠ Could not add';
      })
      .then(function () {
        setTimeout(function () {
          addBtn.classList.remove('is-added');
          addBtn.disabled = false;
          renderQuickView();
          closeQuickView();
        }, 900);
      });
  }

  function handleQVClick(e) {
    if (e.target.matches('.pnb-modal-close, .pnb-modal-backdrop')) {
      if (e.target.matches('.pnb-modal-backdrop') && !e.target.id) return;
      closeQuickView();
      return;
    }
    if (e.target.matches('.pnb-qv-arrow.is-prev')) {
      qvCurrentSlide = (qvCurrentSlide - 1 + qvSlideCount) % qvSlideCount;
      renderQuickView();
      return;
    }
    if (e.target.matches('.pnb-qv-arrow.is-next')) {
      qvCurrentSlide = (qvCurrentSlide + 1) % qvSlideCount;
      renderQuickView();
      return;
    }
    if (e.target.matches('.pnb-qv-dot')) {
      qvCurrentSlide = parseInt(e.target.getAttribute('data-slide'), 10);
      renderQuickView();
      return;
    }
    if (e.target.matches('.pnb-qv-variant') && !e.target.disabled) {
      var name = e.target.getAttribute('data-option');
      var val = e.target.getAttribute('data-value');
      qvSelectedOptions[name] = val;
      renderQuickView();
      return;
    }
    if (e.target.matches('#pnb-qv-add')) {
      handleQvAdd();
    }
  }

  // ------------------------------------------------------------------------
  // GIFT PICKER — radio-style single-select. On change, reconcile the gift
  // line item against the live cart.
  // ------------------------------------------------------------------------
  function handleGiftOptionClick(e) {
    var option = e.target.closest('.pnb-gift-option');
    if (!option || option.classList.contains('is-soldout')) return;
    var radio = option.querySelector('.pnb-gift-radio');
    if (!radio || radio.disabled) return;
    radio.checked = true;
    var all = document.querySelectorAll('.pnb-gift-option');
    all.forEach(function (o) { o.classList.remove('is-selected'); });
    option.classList.add('is-selected');

    syncGiftItem();
  }

  function ensureGiftSelection() {
    var checked = document.querySelector('.pnb-gift-radio:checked');
    if (checked && !checked.disabled) return;
    var firstOk = document.querySelector('.pnb-gift-radio:not([disabled])');
    if (!firstOk) return;
    firstOk.checked = true;
    var opt = firstOk.closest('.pnb-gift-option');
    document.querySelectorAll('.pnb-gift-option').forEach(function (o) { o.classList.remove('is-selected'); });
    if (opt) opt.classList.add('is-selected');
  }

  // ------------------------------------------------------------------------
  // FILTER CHIPS + 5-ROW LIMIT (build-your-bundle grid)
  // ------------------------------------------------------------------------
  var GRID_LIMIT_ROWS = 5;

  function _gridColumns(grid) {
    try {
      var tpl = getComputedStyle(grid).getPropertyValue('grid-template-columns');
      var n = tpl.split(' ').filter(function (x) { return x.trim(); }).length;
      return n > 0 ? n : 2;
    } catch (e) { return 2; }
  }

  function applyGridLimit() {
    var grid = document.getElementById('pnb-product-grid');
    if (!grid) return;
    var active = document.querySelector('.pnb-chip.is-active');
    var filter = active ? active.getAttribute('data-filter') : 'all';
    var isCollapsed = grid.classList.contains('is-collapsed');
    var limit = _gridColumns(grid) * GRID_LIMIT_ROWS;

    var matchingTotal = 0;
    var cards = grid.querySelectorAll('.pnb-card');
    cards.forEach(function (card) {
      var cats = (card.getAttribute('data-cats') || '').split(',');
      var match = filter === 'all' || cats.indexOf(filter) !== -1;
      if (match) matchingTotal++;
    });

    var shown = 0;
    cards.forEach(function (card) {
      var cats = (card.getAttribute('data-cats') || '').split(',');
      var match = filter === 'all' || cats.indexOf(filter) !== -1;
      if (!match) { card.style.display = 'none'; return; }
      if (filter === 'all' && isCollapsed && shown >= limit) {
        card.style.display = 'none';
        return;
      }
      card.style.display = 'flex';
      shown++;
    });

    var wrap = document.getElementById('pnb-grid-more-wrap');
    var btn = document.getElementById('pnb-grid-more');
    var countEl = document.getElementById('pnb-grid-more-count');
    var labelEl = document.getElementById('pnb-grid-more-label');
    var shouldShow = filter === 'all' && matchingTotal > limit;
    if (wrap) wrap.style.display = shouldShow ? 'flex' : 'none';
    if (btn) btn.setAttribute('aria-expanded', String(!isCollapsed));
    if (countEl) countEl.textContent = shouldShow && isCollapsed ? '(' + matchingTotal + ')' : '';
    if (labelEl) labelEl.textContent = isCollapsed ? L.showAll : L.showLess;
    if (filter === 'all' && isCollapsed && matchingTotal > limit) grid.classList.add('has-fade');
    else grid.classList.remove('has-fade');
  }

  function handleChipClick(e) {
    var chip = e.target.closest('.pnb-chip');
    if (!chip) return;
    var chips = chip.parentElement.querySelectorAll('.pnb-chip');
    chips.forEach(function (c) { c.classList.remove('is-active'); });
    chip.classList.add('is-active');
    applyGridLimit();
  }

  function handleGridMoreClick() {
    var grid = document.getElementById('pnb-product-grid');
    if (!grid) return;
    grid.classList.toggle('is-collapsed');
    applyGridLimit();
    if (!grid.classList.contains('is-collapsed')) {
      var cards = grid.querySelectorAll('.pnb-card');
      var limit = _gridColumns(grid) * GRID_LIMIT_ROWS;
      if (cards[limit]) cards[limit].scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // ------------------------------------------------------------------------
  // FAQ ACCORDION
  // ------------------------------------------------------------------------
  function handleFaqClick(e) {
    if (e.target.closest('#pnb-faq-more')) {
      var btn = document.getElementById('pnb-faq-more');
      var extra = document.getElementById('pnb-faq-extra');
      var label = document.getElementById('pnb-faq-more-label');
      if (!btn || !extra) return;
      var isOpen = extra.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
      if (label) label.textContent = isOpen ? L.faqShowLess : L.faqShowMore;
      return;
    }
    var item = e.target.closest('.pnb-faq-item');
    if (!item) return;
    item.classList.toggle('is-open');
  }

  // ------------------------------------------------------------------------
  // AJAX LOAD — fetch products beyond Shopify's 50-product Liquid cap
  // ------------------------------------------------------------------------
  var _ajaxStarted = false;
  var _ajaxPage = 2;
  var _ajaxLimit = 50;

  function _escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function _resizeShopifyImage(url, w) {
    if (!url) return '';
    return url.replace(/\.(jpg|jpeg|png|gif|webp)(\?|$)/i, '_' + w + 'x.$1$2');
  }

  function _deriveCats(product) {
    var handle = (product && product.handle ? product.handle : '').toLowerCase();
    var pt = (product && product.product_type ? product.product_type : '').toLowerCase();
    var title = (product && product.title ? product.title : '').toLowerCase();
    var src = (handle + ' | ' + pt + ' | ' + title).replace(/-/g, ' ');
    var has = function (kws) { for (var i = 0; i < kws.length; i++) { if (src.indexOf(kws[i]) !== -1) return true; } return false; };

    var c = '';
    if (has(['eye pencil', 'eyeliner', 'eyebrow', 'eye shadow', 'eye mask', 'eye patch', 'eye serum', 'eye cream', 'eye contour', 'mascara', 'عيون', 'عين', 'حاجب', 'ظلال', 'كحل', 'ماسكارا'])) c += 'eyes,';
    if (has(['lipstick', 'lip balm', 'lip gloss', 'lip liner', 'شفاه', 'روج', 'احمر شفاه', 'أحمر شفاه'])) c += 'lips,';
    if (has(['foundation', 'bb cream', 'powder', 'concealer', 'primer', 'كريم أساس', 'بودرة', 'كونسيلر', 'برايمر'])) c += 'face,';
    if (has(['blush', 'highlighter', 'contour', 'bronzing', 'أحمر خدود'])) c += 'cheeks,';
    if (has(['brow', 'eyebrow', 'حاجب'])) c += 'brows,';
    if (has(['setting', 'fixing', 'mist', 'fix spray', 'تثبيت'])) c += 'setting,';
    if (has(['remover', 'cleansing', 'cleanser', 'micellar', 'مزيل مكياج', 'ميسيلار'])) c += 'remover,';
    return c;
  }

  function _appendAjaxCard(p) {
    var grid = document.getElementById('pnb-product-grid');
    if (!grid) return;
    if (grid.querySelector('.pnb-card[data-handle="' + p.handle + '"]')) return;

    var variants = p.variants || [];
    var firstAvail = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) { firstAvail = variants[i]; break; }
    }
    var v = firstAvail || variants[0] || {};
    var available = !!v.available;
    var hasVariants = variants.length > 1;
    var price = Math.round(parseFloat(v.price || '0'));
    var firstImg = (p.images || [])[0];
    var imgSrc = firstImg ? _resizeShopifyImage(firstImg.src, 400) : '';
    var cats = _deriveCats(p);
    var btnLabel = available ? L.add : L.soldout;

    var card = document.createElement('article');
    card.className = 'pnb-card' + (available ? '' : ' is-soldout');
    card.setAttribute('data-handle', p.handle);
    card.setAttribute('data-cats', cats);
    card.innerHTML =
      '<span class="pnb-card-badge pnb-card-badge--added">' + _escapeHtml(L.inBundle) + '</span>' +
      '<span class="pnb-card-badge pnb-card-badge--soldout">' + _escapeHtml(L.soldout) + '</span>' +
      '<div class="pnb-card-visual">' +
        (imgSrc ? '<img src="' + _escapeHtml(imgSrc) + '" alt="' + _escapeHtml(p.title) + '" loading="lazy">' : '') +
      '</div>' +
      '<div class="pnb-card-info">' +
        '<h4>' + _escapeHtml(p.title) + '</h4>' +
        (p.product_type && !IS_RTL ? '<div class="pnb-cat">' + _escapeHtml(p.product_type) + '</div>' : '') +
        '<div class="pnb-card-row">' +
          '<span class="pnb-price">' + price + SAR_ICON + '</span>' +
          '<button class="pnb-btn-add"' +
            ' data-variant-id="' + _escapeHtml(v.id) + '"' +
            ' data-product-handle="' + _escapeHtml(p.handle) + '"' +
            ' data-title="' + _escapeHtml(p.title) + '"' +
            ' data-variant-title="' + _escapeHtml(v.title || '') + '"' +
            ' data-price="' + price + '"' +
            ' data-image="' + _escapeHtml(firstImg ? _resizeShopifyImage(firstImg.src, 200) : '') + '"' +
            ' data-has-variants="' + hasVariants + '"' +
            (available ? '' : ' disabled') + '>' + _escapeHtml(btnLabel) + '</button>' +
        '</div>' +
      '</div>';

    var options = (p.options || []).map(function (o, idx) {
      var name = typeof o === 'string' ? o : (o.name || ('Option ' + (idx + 1)));
      var seen = {};
      variants.forEach(function (vv) {
        var val = vv['option' + (idx + 1)];
        if (val != null) seen[val] = true;
      });
      return { name: name, values: Object.keys(seen) };
    });
    var jsonData = {
      handle: p.handle,
      title: p.title,
      brand: p.vendor || '',
      description: (p.body_html || '').replace(/<[^>]+>/g, '').substring(0, 600),
      images: (p.images || []).map(function (i) { return _resizeShopifyImage(i.src, 800); }),
      options: options,
      variants: variants.map(function (vv) {
        return {
          id: vv.id,
          title: vv.title,
          price: Math.round(parseFloat(vv.price || '0')),
          available: !!vv.available,
          inventoryQuantity: null,
          options: [vv.option1, vv.option2, vv.option3].filter(function (x) { return x != null; })
        };
      })
    };

    var jsonScript = document.createElement('script');
    jsonScript.type = 'application/json';
    jsonScript.setAttribute('data-pnb-product', p.handle);
    jsonScript.textContent = JSON.stringify(jsonData);

    grid.appendChild(card);
    grid.appendChild(jsonScript);
  }

  function _interleaveGrid() {
    var grid = document.getElementById('pnb-product-grid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.pnb-card'));
    if (cards.length <= 1) return;

    var buckets = {};
    var order = [];
    cards.forEach(function (card) {
      var cats = (card.getAttribute('data-cats') || '').split(',').filter(Boolean);
      var primary = cats[0] || 'other';
      if (!buckets[primary]) { buckets[primary] = []; order.push(primary); }
      buckets[primary].push(card);
    });

    var interleaved = [];
    var active = true;
    while (active) {
      active = false;
      for (var i = 0; i < order.length; i++) {
        if (buckets[order[i]].length) {
          interleaved.push(buckets[order[i]].shift());
          active = true;
        }
      }
    }
    interleaved.forEach(function (card) { grid.appendChild(card); });
  }

  function loadRemainingProducts() {
    if (_ajaxStarted) return;
    var grid = document.getElementById('pnb-product-grid');
    if (!grid) return;
    var handle = grid.getAttribute('data-collection-handle');
    if (!handle) return;
    var root = grid.getAttribute('data-routes-root') || '/';
    if (root.slice(-1) !== '/') root += '/';
    _ajaxStarted = true;

    function fetchPage() {
      fetch(root + 'collections/' + handle + '/products.json?limit=' + _ajaxLimit + '&page=' + _ajaxPage)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          var products = data.products || [];
          products.forEach(_appendAjaxCard);
          if (products.length === _ajaxLimit) {
            _ajaxPage++;
            fetchPage();
          } else {
            _interleaveGrid();
            if (typeof applyGridLimit === 'function') applyGridLimit();
            if (typeof renderState === 'function') renderState();
          }
        })
        .catch(function () { /* silent fail */ });
    }

    fetchPage();
  }

  // ------------------------------------------------------------------------
  // INIT
  // ------------------------------------------------------------------------
  function handleWidgetCta() {
    // Take the customer to their cart so they can review and check out.
    var grid = document.getElementById('pnb-product-grid');
    var root = (grid && grid.getAttribute('data-routes-root')) || '/';
    if (root.slice(-1) !== '/') root += '/';
    window.location.href = root + 'cart';
  }

  function init() {
    // Mark Miss W Pro as the most-recently-visited bundle so the layout-injected
    // "Back to your bundle" tab renders on subsequent product pages. Clears
    // sibling bundle flags (food, baby) per most-recent-visit-wins.
    try {
      sessionStorage.removeItem('pnbf_food_bundle_active');
      sessionStorage.removeItem('pnbf_food_bundle_path');
      sessionStorage.removeItem('pnbf_btb_dismissed');
      sessionStorage.removeItem('pnb_baby_bundle_active');
      sessionStorage.removeItem('pnb_baby_bundle_path');
      sessionStorage.removeItem('pnb_baby_btb_dismissed');
      sessionStorage.removeItem('pnb_misswpro_btb_dismissed');
      sessionStorage.setItem('pnb_misswpro_bundle_active', '1');
      sessionStorage.setItem('pnb_misswpro_bundle_path', IS_RTL ? '/ar/pages/miss-w-pro-bundle' : '/pages/miss-w-pro-bundle');
    } catch (e) { /* private browsing — no-op */ }

    // Fetch real Shopify cart, paint widget, then reconcile gift item if needed.
    cartFetch()
      .then(function () { renderState(); return syncGiftItem(); })
      .catch(function () { renderState(); });

    loadRemainingProducts();

    var root = document.querySelector('.pnb-bundle');
    if (root) {
      root.addEventListener('click', function (e) {
        handleAddDirectly(e);
        handleCardClick(e);
        handleBestsellerClick(e);
        handleChipClick(e);
        handleFaqClick(e);
        handleGiftOptionClick(e);
      });
    }

    var qvModal = document.getElementById('pnb-qv-modal');
    if (qvModal) qvModal.addEventListener('click', handleQVClick);

    var rewardsCta = document.getElementById('pnb-rewards-cta');
    if (rewardsCta) rewardsCta.addEventListener('click', handleWidgetCta);
    var rewardsToggle = document.getElementById('pnb-rewards-toggle');
    if (rewardsToggle) {
      rewardsToggle.addEventListener('click', function () {
        var p = document.getElementById('pnb-rewards-panel');
        if (p) p.classList.toggle('is-collapsed');
      });
    }

    var gridMoreBtn = document.getElementById('pnb-grid-more');
    if (gridMoreBtn) gridMoreBtn.addEventListener('click', handleGridMoreClick);

    applyGridLimit();
    ensureGiftSelection();

    var _resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(_resizeTimer);
      _resizeTimer = setTimeout(applyGridLimit, 150);
    });

    document.querySelectorAll('[data-scroll-to]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(el.getAttribute('data-scroll-to'));
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeQuickView();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
